/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import EditScheduleTrigger from './EditScheduleTrigger';
import TriggerSummary from './TriggerSummary';
import { useNavigate } from 'react-router-dom';
// @ts-ignore
import { NotificationManager } from 'react-notifications';
// @ts-ignore
import Papa from 'papaparse/papaparse.min.js';
import type {appConfigs } from '../types/types';
import MainLayout from '../Layouts/Mainlayout';
import { Grid, Tooltip } from '@mui/material';
import OutlineButton from '../MUICustomButton/OutlineButton';
import GradientButton from '../MUICustomButton/GradientButton';
import type { TriggerFormData} from '../types/types';
import { TRIGGER_ALREADY_STARTED_MESSAGE, UNKNOWN_ERR } from 'src/constants/constant';
import { getlisttriggerById, updatelisttrigger } from 'src/services/triggerService';
import { useParams } from 'react-router-dom';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {IdeaSolidRounded} from '@hugeicons-pro/core-solid-rounded';
import moment from 'moment';
import type { TooltipProps } from '@mui/material/Tooltip';
import {tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { checkEventPermission } from 'src/common/utility/utility';

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} placement="bottom" />
  ))(({ theme }) => ({
      [`& .${tooltipClasses.arrow}`]: {
          color: theme.palette.common.black,
      },
      [`& .${tooltipClasses.tooltip}`]: {
          backgroundColor: theme.palette.common.black,
      },
}));

const steps = ['Import List', 'Schedule Trigger', 'Confirmation'];
export interface ApiResponse {
status: number;
data: {
    data: [];
    result:number;
};
}

function EditTriggerForm(): JSX.Element {
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [MaxRequestBodySizeData, setMaxRequestBodySizeData] =
    useState<string>('');
  const navigate = useNavigate();
  const [savedTriggerData, setSavedTriggerData] = useState<TriggerFormData>();
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [isFormValid, setIsFormValid] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [savedFileName, setSavedFileName] =useState<string>('');
  const [pausedValue, setpausedValue] =useState<boolean>(true);
  const [startDatevalue, seStartDateValue] =useState<string>('');
  const [totalNpiRecords,setTotalNpiRecords] = useState<number>(0);
  const param = useParams();
    const {id} = param;
  console.log(isFormValid);
  console.log(loading);
  useEffect(() => {
    const storedAppConfig = localStorage.getItem('appConfigs');
    if (storedAppConfig !== null && storedAppConfig !== '') {
      try {
        const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];
        const maxRequestBodySize = parsedAppConfig.find(
          (item) => item.configName === 'MaxRequestBodySize',
        )?.configValue;
        if (maxRequestBodySize != null) {
          setMaxRequestBodySizeData(maxRequestBodySize);
        }
      } catch (error) {
        console.error('Error parsing appConfig data:', error);
      }
    }
  }, []);
  useEffect(() => {
    console.log(id);
    setLoading(true)
    getlisttriggerById(id as string)
      .then(
        (res: ApiResponse) => {
          if (res.status === 200) {         
            //@ts-ignore     
            setSavedTriggerData(res.data.data);
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
               //@ts-ignore
              if(res.data.data[0].sourceFileName == null){
                //@ts-ignore
                setSavedFileName(res.data.data[0].listFileName+'.csv');
              }else{
                //@ts-ignore
                setSavedFileName(res.data.data[0].sourceFileName);
              }
            
            
            //@ts-ignore
            setpausedValue(res.data.data[0].isPaused);
            //@ts-ignore
            seStartDateValue(res.data.data[0].startDate);

            //@ts-ignore
            if (res.data.data[0]?.totalNPI) {
              //@ts-ignore
              setTotalNpiRecords(res.data.data[0].totalNPI);
              //@ts-ignore
              sessionStorage.setItem("totalNpiRecords", JSON.stringify(res.data.data[0].totalNPI));
            }

            setLoading(false)
          }
        }
      ) 
      .catch (
        error => console.log("Error: ", error)
      )
      .finally(() => {
        setLoading(false)
      })

}, [id]);
  // Convert maxRequestBodySizeData to MB and round it
  const mbValue = Math.round(parseInt(MaxRequestBodySizeData) / 1024 / 1024);
  const handleFormValidation = (isValid: boolean): void => {
    console.log(isValid);
    setIsFormValid(isValid);
};
  const onDrop = useCallback(
    (acceptedFiles: any, rejectedFiles: any) => {
      if (rejectedFiles.length > 0) {
        NotificationManager.error('Please select valid file');
      } else {
        if (MaxRequestBodySizeData !== "") {
          validateFile(acceptedFiles);
        } else {
          NotificationManager.error('Max request body size not available.');
        }
      }
    },
    [MaxRequestBodySizeData],
  );
  const validateFile = (selectedFiles: File[]): void => {
    let csv: any;
    let data: any;
    if (selectedFiles[0]?.size > parseInt(MaxRequestBodySizeData)) {
        
        NotificationManager.error(`File size must be less than ${mbValue} MB`);
        return;
    }

    // Check file extension
    const extension = selectedFiles[0]?.name.split('.').pop()?.toLowerCase();
    if (extension !== 'csv') {
        NotificationManager.error("The file must be in CSV format.");
        return;
    }

    const reader = new FileReader();

    if (selectedFiles.length > 0) {
        reader.onload = function () {
            // Parse CSV data
            data = reader.result;

            // Parse data with PapaParse
            csv = Papa.parse(data, {
                delimiter: ",",
                download: false,
                dynamicTyping: false,
                encoding: "",
                header: false,
                preview: 0,
                skipEmptyLines: false,
                step: undefined,
                worker: false,
            });

            const records = csv.data as string[][];

            // Validate file content
            if (records.length === 0) {
                NotificationManager.error("The file is empty. Please select a valid file with at least one record.");
                return;
            }

            const headerRow = records[0];
            if (!headerRow || headerRow.length === 0) {
                NotificationManager.error("The file must contain at least one column.");
                return;
            }

            // Check for any empty column headers
            if (headerRow.some((header: string) => header.trim() === "")) {
                NotificationManager.error("The file contains empty headers. Please provide valid column headers.");
                return;
            }

            const trimmedHeaders = headerRow.map((header: string) => header.trim().toLowerCase());
            const uniqueHeaders = new Set(trimmedHeaders);
            if (uniqueHeaders.size !== headerRow.length) {
                NotificationManager.error("The file contains duplicate column headings. Please ensure all column headers are unique.");
                return;
            }

            // Validate column headers for SQL naming conventions (allow letters, numbers, spaces, and underscores)
            const invalidHeaderPattern = /[^a-zA-Z0-9 _]/; // Disallow characters except letters, numbers, spaces, and underscores
            const invalidHeaders = headerRow.filter((header: string) => invalidHeaderPattern.test(header.trim()));
            if (invalidHeaders.length > 0) {
                NotificationManager.error(                    
                    "Invalid column headings found."
                );
                return;
            }

            if (records.length === 1) {
                NotificationManager.error("The file must contain at least one data record.");
                return;
            }
  // Find NPI column index
  const npiColumnIndex = trimmedHeaders.findIndex(header => header.toLowerCase() === 'npi'); 
 if (!trimmedHeaders.includes("npi")) {
              NotificationManager.error('The file must contain an "NPI" column.');
              return;
          }
  // Count distinct NPI values if NPI column exists
  let distinctNpiCount = 0;
  if (npiColumnIndex !== -1) {
      const npiValues = new Set(
          records
              .slice(1) // Skip header row
              .map(row => row[npiColumnIndex])
              .filter(npi => npi && npi.trim() !== '') // Filter out empty values
      );
      distinctNpiCount = npiValues.size;
  }
  setTotalNpiRecords(distinctNpiCount);
  sessionStorage.setItem("totalNpiRecords", JSON.stringify(distinctNpiCount));
            setSelectedFiles(selectedFiles);
            NotificationManager.success("File is valid and ready for upload.");
        }
    }

    // Read CSV file as text
    reader.readAsText(selectedFiles[0]);
};    

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'text/csv': ['.csv'] },
    maxFiles: 1,
  });

  const [activeStep, setActiveStep] = React.useState(0);
  
  const handleNext = async (): Promise<void> => {
    console.log(savedFileName)
    console.log(32323)
    if (activeStep === 0 && selectedFiles.length === 0 && savedFileName == "") {
        NotificationManager.error('Please upload a file before proceeding');
        return;
    }
    if (activeStep === 1) {
      setSubmitAttempted(true);
      // Reset the submit attempt flag after a short delay
      setTimeout(() => {
          setSubmitAttempted(false);
      }, 100);
      return;
  }
    setActiveStep((prevStep) => prevStep + 1);
};
  const handleBack = (): void => {
    setActiveStep((prevStep) => prevStep - 1); // Go to the previous step
  };

    const handleCancel = (): void => {
    navigate('/trigger');
  };

  const handleFormSubmit = (data: TriggerFormData): void => {
    setLoading(true);
    try {
      const userData = JSON.parse(localStorage.getItem("user") ?? "");
      
      const triggerData = {
        Id: id,
        clientId: userData?.clientId ?? 0,
        campaignId: data.campaignId,
        listTriggerName: data.triggername,
        startDate: data.startOn,
        endDate: data.triggerenddate,
         //@ts-ignore
        totalNPI: savedFileName != "" ? savedTriggerData[0].totalNPI : totalNpiRecords,
        updatedBy: userData.id
      };
  
      const formData = new FormData();
      if (selectedFiles[0] || savedFileName != "") {
        formData.append('file', selectedFiles[0]);
            } else {
              NotificationManager.error('No file selected');
              return;
          }
      formData.append('requestData', JSON.stringify(triggerData));
  
      updatelisttrigger(formData)
        .then((res: ApiResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              // NotificationManager.success(TRIGGER_UPDATE_SUCCESS_MESSAGE, '', 5000);
              // Add delay and fetch updated data
              setTimeout(() => {
                getlisttriggerById(id as string)
                  .then((response: ApiResponse) => {
                    if (response.status === 200) {
                       //@ts-ignore
                      setSavedTriggerData(response.data.data);
                     
                    }
                  })
                  .catch((error) => {
                    console.error("Error fetching updated data:", error);
                  });
              }, 1000); // 1 second delay
              setActiveStep((prevStep) => prevStep + 1);
            }else{
              console.error("unknown error occurred");
              NotificationManager.error(UNKNOWN_ERR);
            }
          }
        })
        .catch((error: any) => {
          console.error("Error", error);
          NotificationManager.error('Failed to submit trigger');
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
      console.error("Error processing form submission:", error);
      NotificationManager.error('Error processing form data');
    }
  };
const  handleRemoveSelectedFiles =() : void=> {
    setSelectedFiles([]);
    setSavedFileName("");
}
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        {/* <h2 className="text-2xl font-semibold text-title mb-[20px]">New Request</h2> */}
        <div className="flex justify-between items-center">
          <div className="w-full">
            <div>
              <h1 className="text-2xl text-title font-semibold">
                Edit Trigger
              </h1>

              <Box sx={{ flexGrow: 1 }}>
              {loading ?
        <div className='flex justify-center items-center relative '><span className="loading loading-spinner text-primary"></span></div> :
                <div className="campaign-form-container">
                  <Grid>
                    <Box sx={{ width: '60%', marginTop: '10px', mx: 'auto' }}>
                      <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                          <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                          </Step>
                        ))}
                      </Stepper>

                      {activeStep === 0 && (
                        <div style={{ marginTop: '40px' }}>
                          {(savedFileName || selectedFiles.length > 0) ? (
      <div className="dropzone">
        <span className="font-semibold">
          {savedFileName ? `${savedFileName}` : selectedFiles[0]?.name}
        </span>
        <a
          href="javascript:void(0)"
          onClick={() => handleRemoveSelectedFiles()}
          style={{ color: 'red', paddingTop: '10px' }}
        >
          Remove
        </a>
      </div>
    ) : (
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Drop the files here ...</p>
        ) : (
          <>
            <p>
            <strong className='font-semibold'>Drag and drop or</strong>
              <span
                style={{
                  color: '#d6242c',
                  cursor: 'pointer',
                  fontWeight: '600',
                }}
              >
                {' '}
                Click here{' '}
              </span>
              <strong className='font-semibold'>to choose file.</strong>
            </p>

            <span
              style={{
                display: 'block',
                marginTop: '20px',
                fontSize: '14px',
                color: '#3A3A3A',
              }}
            >
              {mbValue && `Max size ${mbValue} MB . `} File format: CSV
            </span>
          </>
        )}
      </div>
    )}

                          <Box
                            sx={{
                              textAlign: 'left',
                              mt: 3,
                              p: 1,
                              bgcolor: '#f5f5f5',
                              borderRadius: '8px',
                              boxShadow: 0,
                            }}
                          >
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: '600',
                                color: '#3A3A3A',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                                <HugeiconsIcon
                                  icon={IdeaSolidRounded}
                                  size={20}
                                  color="#3A3A3A"
                                  strokeWidth={0.2}
                                  style={{ marginRight: 10 }}
                                  />{' '}
                              NPI Import Instructions
                            </Typography>

                            <ul
                              style={{
                                paddingLeft: '20px',
                                marginTop: '12px',
                                color: '#3A3A3A',
                                lineHeight: '1.8',
                              }}
                            >
                              <li
                                style={{
                                  listStyleType: 'disc',
                                  marginBottom: '8px',
                                }}
                              >
                              <a
                                    href="/assets/listtrigger-files/sample.csv"
                                    download="sample.csv"
                                    style={{
                                      color: '#d6242c',
                                      textDecoration: 'underline',
                                    }}
                                  >
                                    Download
                               
                                </a>{' '}
                                a sample CSV file
                              </li>
                              <li
                                style={{
                                  listStyleType: 'disc',
                                  marginBottom: '8px',
                                }}
                              >
                                Ensure that your file is in CSV format.
                              </li>
                              <li
                                style={{
                                  listStyleType: 'disc',
                                  marginBottom: '8px',
                                }}
                              >
                                Verify that the file size does not exceed{' '}
                                {mbValue} MB.
                              </li>
                            </ul>
                          </Box>
                        </div>
                      )}
                    </Box>
                    {activeStep === 1 && (
                      <div style={{ marginTop: '40px' }}>
                        {/* @ts-ignore */}
                        <EditScheduleTrigger 
                          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
                        savedTriggerData={savedTriggerData}
    onFormValidation={handleFormValidation}
    onDataSubmit={handleFormSubmit}
    submitAttempted={submitAttempted}
/>
                      </div>
                    )}
                    {activeStep === 2 && (
                     //@ts-ignore
                        <TriggerSummary savedTriggerData = {savedTriggerData} />
                      
                    )}
                  </Grid>
{activeStep !== 2 && 
                  <div className="bg-white p-4 mt-4">
                    {/* Gray Horizontal Line */}
                    <hr
                      className="border-t"
                      style={{ borderColor: '#D3D3D3' }}
                    />

                    {/* Buttons */}

                    <div className="flex gap-2 justify-end mt-4">
                      {activeStep !== 0 &&  (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            gap: '12px',
                          }}
                        >
                          <button
                            type="button"
                            onClick={handleBack}
                            style={{
                              background: 'none',
                              border: 'none',
                              color: '#666',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                              padding: '8px 16px',
                              fontSize: '14px',
                            }}
                          >
                            <span style={{ color: '#666' }}>←</span> Back
                          </button>
                        </div>
                      )}
                      
                          <OutlineButton
                            color="gray"
                            onClick={() => handleCancel()}
                            width="130px"
                          >
                            Cancel
                          </OutlineButton>
                          <BootstrapTooltip title={activeStep === 1 && !pausedValue && moment(startDatevalue).isBefore(moment()) ? TRIGGER_ALREADY_STARTED_MESSAGE : ""}>
                            <span> {/* Needed to wrap the button since Tooltips don't work on disabled buttons directly */}
                              <GradientButton
                                color="red"
                                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                                onClick={() => handleNext()}
                                width="130px"
                                disabled={
                                  activeStep === 1 &&
                                  (
                                    !checkEventPermission('LISTTRIGGER_UPDATE') ||
                                    (!pausedValue && moment(startDatevalue).isBefore(moment()))
                                  )
                                }
                              >
                                {'Next >'}
                              </GradientButton>
                            </span>
                          </BootstrapTooltip>
                    </div>
                  </div>

                    }
                </div>
}
              </Box>
            </div>
          </div>
        </div>
      </MainLayout>
    </div>
  );
}

export default EditTriggerForm;
